import { styled, TableBody, TableRow } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import { Link } from 'react-router-dom'
import {
   StyledTable,
   StyledTableCell,
   StyledTableHead,
   StyledTableHeadCell,
   StyledTableRow,
} from 'shared/components/StyledTableComponents'

const StyledLink = styled('a')(({ theme }) => ({
   textDecoration: 'none',
   color: 'black',
   fontWeight: 'bold',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
   },
}))

const StyledReactLink = styled(Link)(({ theme }) => ({
   textDecoration: 'none',
   color: 'black',
   fontWeight: 'bold',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
   },
}))

export default function Cookies() {
   return (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            textAlign: 'justify',
            px: { lg: '24px', md: '24px', xs: '12px' },
         }}
      >
         <Typography textAlign="center" variant="h3" color="primary.dark">
            Jak Euromaster Polska sp. z o.o. używa plików cookie
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. dokłada wszelkich starań, aby chronić Państwa dane osobowe, w sposób jasny i
            wyraźny informując, jakie dane zbieramy i jak z nich korzystamy. Podczas korzystania z naszej strony
            internetowej lub aplikacji zarządzanej przez Euromaster Polska sp. z o.o., informacje mogą być gromadzone za
            pomocą plików cookie, aby odróżnić Cię od innych użytkowników naszej witryny lub aplikacji.
         </Typography>
         <Typography>
            Ta polityka określa cele dla których my i nasi partnerzy używamy plików cookie lub podobnych technologii
            oraz jak możesz zarządzać swoimi preferencjami.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            1. Kim jesteśmy i jak można się z nami skontaktować
         </Typography>
         <Typography>
            Pełna nazwa naszej spółki to Euromaster Polska sp. z o.o. “Euromaster Polska sp. z o.o.” i jesteśmy
            administratorem danych. Z Euromaster Polska sp. z o.o. można skontaktować się:
         </Typography>
         <ul>
            <li>Wysyłając e-mail na adres: marketplace.smr@euromaster.pl</li>
            <li>Drogą listowną na adres: Domaniewska 45, 02-672 Warszawa</li>
            <li>Telefonicznie pod numerem + 48 22 395 62 90</li>
         </ul>
         <Typography variant="h6" fontWeight="bold">
            2. Informacje o Inspektorze Ochrony Danych
         </Typography>
         <Typography>
            Wszyscy pracownicy Euromaster Polska sp. z o.o. są zobowiązani do ochrony i poszanowania Państwa
            prywatności. Wszystkimi kwestiami związanymi z danymi osobowymi w Euromaster Polska sp. z o.o. zajmują się
            Inspektor Ochrony Danych Osobowych. Mogą Państwo skontaktować się z Inspektorem Ochrony Danych wysyłając
            e-mail na adres:{' '}
            <StyledLink href="mailto:rodo@euromaster.pl" target="_blank">
               rodo@euromaster.pl
            </StyledLink>
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            3. Co to są pliki cookie?
         </Typography>
         <Typography>
            Plik cookie to plik tekstowy lub element oprogramowania, który rejestruje informacje związane z nawigacją
            twojego terminala w Internecie. Jest pod kontrolą twojej przeglądarki i czasami nosi unikalny i losowy
            numer.
         </Typography>
         <Typography>
            Gdy Euromaster Polska sp. z o.o. używa terminu ”cookie”, mogą to być cookie, znaczniki lub podobne
            technologie oparte na dostępie do urządzenia, którego używasz do przechowywania i odczytywania plików cookie
            (komputer, tablet, smartfon) podczas korzystania z naszych stron. Strony trzecie, takie jak nasi partnerzy i
            usługodawcy, mogą wykorzystywać pliki cookie i podobne technologie w związku z naszymi Usługami.
         </Typography>
         <Typography>
            Plik cookie umożliwia Euromaster Polska sp. z o.o. lub jej partnerom jako wydawcom plików cookie, w okresie
            ich ważności, rozpoznawanie twojego urządzenia za każdym razem, gdy uzyskuje dostęp do treści cyfrowych
            zawierających pliki cookie tego samego emitenta.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            4. Inne polityki, do których zachęcamy do przeczytania
         </Typography>
         <Typography>
            Niektóre informacje z plików cookie nie identyfikują cię bezpośrednio ani pośrednio i nie stanowią danych
            osobowych. Inni mogą Cię zidentyfikować i stanowić dane osobowe i podlegają specjalnej ochronie. Aby uzyskać
            więcej informacji o tym, jak Euromaster Polska sp. z o.o. wykorzystuje Twoje dane osobowe, zachęcamy Cię
            jednak do zapoznania się z naszą Polityką prywatności{' '}
            <StyledReactLink to="/privacy-policy"> https://smr.euromaster.pl/privacy-policy</StyledReactLink> oraz
            polityką naszych partnerów dostępną poprzez moduł zarządzania twoimi preferencjami.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            5. Dlaczego Euromaster Polska sp. z o.o. wykorzystuje cookie?
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. nieustannie poszukuje nowych sposobów na ulepszenie swoich stron internetowych,
            aby zaoferować Państwu, użytkownikom Internetu lepszą usługę i doświadczenia. W związku z tym Euromaster
            Polska sp. z o.o. wykorzystuje różne rodzaje cookie (patrz poniżej), które mogą wymagać zgody internauty
            (np. reklamowe pliki cookie) przed zainstalowaniem ich na urządzeniu.
         </Typography>
         <Typography>
            W każdym przypadku, masz kontrolę nad tymi plikami cookie. Dlatego możesz je odrzucić, skonfigurować lub
            zniszczyć.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            6. W jaki sposób Euromaster Polska sp. z o.o. informuje cię o używanych przez ciebie ciasteczkach?
         </Typography>
         <Typography>
            Po pierwszym wejściu na stronę Euromaster Polska sp. z o.o.urządzenie umożliwiające zarządzanie zgodą
            użytkowników powraca na tę stronę, która zawiera wszystkie informacje na temat plików cookie, które są
            następnie używane.
         </Typography>
         <Typography>
            Polityka plików cookie jest dostępna w zakładce „Polityka dotycząca cookies” w stopce naszej witryny.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            7. Jak odinstalować cookie i / lub zarządzać preferencjami?
         </Typography>
         <Typography sx={{ ml: '24px' }}>a. Ustawienia twojej przeglądarki</Typography>
         <Typography>
            Większość przeglądarek pozwala kontrolować pliki cookie za pomocą ich ustawień, które można dostosować w
            celu odzwierciedlenia Twojej zgody na korzystanie z plików cookie. Ponadto większość przeglądarek umożliwia
            również usuwanie plików cookie. Więcej informacji na temat elementów sterujących przeglądarki znajduje się w
            dokumentacji przeglądarki. Aby dowiedzieć się więcej na temat ustawiania preferencji przeglądarki, możesz
            również odwiedzić następującą witrynę:{' '}
            <StyledLink href="https://www.youronlinechoices.com/" target="_blank">
               https://www.youronlinechoices.com/
            </StyledLink>
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            b. Zarządzaj swoimi preferencjami za pomocą modułu zarządzania plikami cookie
         </Typography>
         <Typography>
            Witryna Euromaster Polska sp. z o.o. ma moduł do zarządzania zgodą użytkowników strony internetowej lub
            aplikacji. To rozwiązanie umożliwia gromadzenie, przechowywanie i przekazywanie zgody do Euromaster Polska
            sp. z o.o. lub zainteresowanym partnerom.
         </Typography>
         <Typography>
            Kiedy po raz pierwszy odwiedzasz naszą stronę lub aplikację, okno informacyjne pozwoli ci wskazać twój
            wybór. Możesz je zaakceptować, skonfigurować, odrzucić lub nawet uzyskać dostęp do naszej polityki
            zarządzania plikami cookie, klikając przyciski znajdujące się w naszym module zarządzania zgodami.
         </Typography>
         <Typography>
            Moduł zarządzania zgodami pozwala wskazać preferencje globalnie, na potrzeby plików cookie lub według
            kategorii partnerów. Masz również dostęp dla wszystkich partnerów do ich polityki prywatności.
         </Typography>
         <Typography>
            Możesz zaakceptować lub odrzucić pliki cookie, ale pamiętaj, że odmowa może sprawić, że przeglądanie naszej
            witryny będzie mniej przyjazne dla użytkownika i będzie mniej przydatne.
         </Typography>
         <Typography>
            Twoja zgoda jest ważna przez okres nieprzekraczający okresu przechowywania pliku cookie w odniesieniu do
            jego celu i obowiązujących przepisów. Podobnie, jeśli odrzucisz pliki cookie, Twój wybór zostanie zachowany
            przez określony czas. Pod koniec tego okresu lub jeśli usuniesz plik cookie powiązany z wybranym miejscem do
            przechowywania, moduł zarządzania zgodami zostanie zaoferowany ponownie.
         </Typography>
         <Typography>
            Niezależnie od początkowego wyboru, zawsze możesz go zmodyfikować w dowolnym momencie, klikając przycisk
            ”zarządzanie plikami cookie” niniejszej Polityki dotyczącej plików cookie lub zakładkę ”Polityka dotycząca
            cookies” u dołu każdej strony naszej witryny.
         </Typography>
         <Typography variant="h6" fontWeight="bold">
            8.Jakie rodzaje plików cookie są używane przez Euromaster Polska sp. z o.o.?{' '}
         </Typography>
         <Typography>Pliki cookie można klasyfikować na różne sposoby:</Typography>
         <Typography>Według czasu przechowywania:</Typography>
         <Typography>
            - <b>Cookie ”Sesyjny”</b>: jest to plik cookie, który jest usuwany, gdy użytkownik zamyka przeglądarkę.
         </Typography>
         <Typography>
            - <b>Cookie ”Trwały”</b>: jest to plik cookie, który pozostaje na komputerze urządzeniu użytkownika przez
            określony czas po zakończeniu sesji przeglądania. Maksymalny okres przechowywania jest regulowany w
            parametrach plików cookies, przepisami lub zaleceniami odpowiedniego organu ochrony danych. Użytkownik może
            w dowolnym momencie usunąć pliki cookies.
         </Typography>
         <Typography>Według ich pochodzenia::</Typography>
         <Typography>
            - <b>Cookie ”pierwszego poziomu”</b>:są umieszczane bezpośrednio przez Euromaster Polska sp. z o.o. lub jej
            usługodawców.
         </Typography>
         <Typography>
            - <b>Cookie ”stron trzecich”</b>: są umieszczane przez partnerów autoryzowanych przez Euromaster Polska sp.
            z o.o. (na przykład agencję reklamową). Gdy używają plików cookie, ci partnerzy zewnętrzni są odpowiedzialni
            za pliki cookie, których używają. Zapraszamy do zapoznania się z ich polityką zarządzania plikami cookie.
            Możesz również użyć własnych narzędzi do zbierania i zarządzania zgodami, aby ustawić swoje preferencje.
         </Typography>
         <Typography>
            Według innych celów związanych z ich funkcjonowaniem: Pliki cookie mogą służyć kilku celom. Określenie
            kategorii może się różnić. Dla lepszego zrozumienia, Euromaster Polska sp. z o.o.,określa je w kategorie
            zdefiniowane poniżej.
         </Typography>
         <Typography>
            <b>- Cookie Niezbędne </b>
         </Typography>
         <Typography>
            Pliki cookie ściśle niezbędne do świadczenia usługi komunikacji online drogą elektroniczną są niezbędne do
            prawidłowego funkcjonowania strony internetowej. Ich dezaktywacja powoduje znaczne trudności w korzystaniu z
            witryny, a nawet niemożność korzystania z oferowanych przez nią usług. Pliki cookie obejmują wiele celów.
            Pozwalają na przykład zidentyfikować terminale do kierowania komunikacją, numerować „pakiety” danych, aby
            kierować je w pożądanej kolejności, wykryć błędy transmisji lub utratę danych, zachować w pamięci zawartość
            koszyk podczas sesji, dostosuj interfejs użytkownika (język, prezentacja usługi) lub nawet uwierzytelnienie
            za pomocą usługi.
         </Typography>
         <Typography>
            Te pliki cookie pozwalają również Euromaster Polska sp. z o.o. zachować wybór wyrażony przez użytkowników w
            zakresie preferencji plików cookie, aby nie żądać ich ponownie przez określony czas.
         </Typography>
         <ul>
            <li>
               Te pliki cookie i znaczniki są wykorzystywane na podstawie uzasadnionego interesu Euromaster Polska sp. z
               o.o. Ponieważ są one absolutnie niezbędne do nawigacji, twoja wcześniejsza zgoda nie jest wymagana. Te
               pliki cookie nie są zarządzane przez nasz moduł zarządzania zgody.
            </li>
         </ul>
         <Typography fontWeight="bold">Niezbędne pliki cookie:</Typography>
         <StyledTable>
            <StyledTableHead>
               <StyledTableHeadCell>Nazwa</StyledTableHeadCell>
               <StyledTableHeadCell>Wprowadzone przez</StyledTableHeadCell>
               <StyledTableHeadCell>Cel</StyledTableHeadCell>
               <StyledTableHeadCell>Czas trwania</StyledTableHeadCell>
            </StyledTableHead>
            <TableBody>
               <StyledTableRow>
                  <StyledTableCell>Motorro</StyledTableCell>
                  <StyledTableCell>Motorro</StyledTableCell>
                  <StyledTableCell>Przechowywanie informacji niezbędnych do używania Motorro</StyledTableCell>
                  <StyledTableCell>W trakcie używania Motorro</StyledTableCell>
               </StyledTableRow>
            </TableBody>
         </StyledTable>
         <Typography fontWeight="bold">- Cookie Funkcjonalne</Typography>
         <Typography>
            Funkcjonalne pliki cookie służą do poprawy komfortu przeglądania. Zapamiętują dokonane wybory (na przykład
            twoją nazwę użytkownika, zapisz ostatnie opcje trasy) i zapewniają spersonalizowane usługi. Dzięki tym
            plikom cookie nie musisz wprowadzać pewnych informacji za każdym razem, gdy łączysz się z naszą witryną lub
            aplikacją. Zapamiętują dokonane zmiany dotyczące rozmiaru tekstu, czcionki lub innych części stron
            internetowych, które można dostosować.
         </Typography>
         <Typography>
            Funkcjonalne pliki cookie nie będą wykorzystywane do wysyłania reklam w naszej witrynie lub na innych
            stronach internetowych. <br />
            Możesz je zaakceptować lub odrzucić, ale blokując je, możliwe jest, że poprzednie wybory usług nie zostaną
            zachowane w pamięci.
         </Typography>
         <ul>
            <li>Te pliki cookie są wykorzystywane na podstawie Twojej uprzedniej zgody.</li>
         </ul>
         <Typography fontWeight="bold">- Cookies statystyczne</Typography>
         <Typography>
            Pliki cookie służące do pomiaru odbiorców służą do poprawy wydajności korzystania ze stron internetowych
            Euromaster Polska sp. z o.o. Te pliki cookie przechowują tylko identyfikator użytkownika Internetu
            (specyficzny dla każdego pliku cookie) i w żadnym wypadku nie są wykorzystywane do zbierania informacji
            personalnych należących do odwiedzających. Zebrane dane umożliwiają dostarczenie anonimowych danych
            statystycznych dotyczących częstości (liczba odwiedzających i odwiedzonych stron, czas wizyty, komunikaty o
            błędach, liczba odwiedzin, częstotliwość ich powrotu ...) ”.
         </Typography>
         <Typography>
            Analityczne pliki cookie mogą być instalowane i chronione przez partnerów, którzy realizują dodatkowe cele.
            Euromaster Polska sp. z o.o. może jednak ograniczyć ich wykorzystanie do celów wymaganych statystyk
            analitycznych.
         </Typography>
         <Typography>
            Możesz zaakceptować lub odmówić, ale blokując, Euromaster Polska sp. z o.o.ma mniej informacji, aby poprawić
            wydajność swojej witryny.
         </Typography>
         <ul>
            <li>Te pliki cookie są wykorzystywane na podstawie Twojej uprzedniej zgody.</li>
         </ul>
         <Typography fontWeight="bold">- Cookies dotyczące reklamy</Typography>
         <Typography>
            Pliki cookie targetowania i śledzenia pozwalają podmiotom zewnętrznym świadczyć usługi, głównie reklamowe, i
            poprawiać ich wydajność. Te pliki cookie mogą zapamiętywać odwiedzane strony i witryny oraz mogą gromadzić
            dane osobowe, głównie adres IP terminala, z którego korzysta użytkownik Internetu. Zebrane informacje mogą
            być udostępniane stronom trzecim.
         </Typography>
         <Typography>
            Są to na przykład pliki cookie, które umożliwiają agencjom reklamowym oferowanie reklam dostosowanych do
            obszarów zainteresowania zgodnie z przeglądaniem stron Euromaster Polska sp. z o.o. lub ograniczają ich
            powtarzanie. Te pliki cookie wymagają Twojej zgody. W takim przypadku na pierwszej stronie witryny pojawi
            się dobrze widoczny baner z prośbą o zgodę na zainstalowanie tych plików cookie.
         </Typography>
         <Typography>
            Euromaster Polska sp. z o.o. i dostawcy zewnętrzni, w tym Google, wspólnie używają zastrzeżonych plików
            cookie i zewnętrznych plików cookie do uzyskiwania informacji, optymalizacji i wyświetlania reklam na
            podstawie odwiedzin na stronie. Euromaster Polska sp. z o.o. i dostawcy używają również tych dwóch rodzajów
            plików cookie w celu ustalenia związku między odwiedzinami zarejestrowanymi w witrynie a wyświetleniami
            reklam, innym wykorzystaniem usług reklamowych i interakcjami z tymi wyświetleniami reklam i tymi usługami
            reklamowymi. Wreszcie Euromaster Polska sp. z o.o. i dostawcy używają tych dwóch rodzajów plików cookie, aby
            zachować Twoje zainteresowania i dane demograficzne, aby zaoferować Ci ukierunkowane reklamy.
         </Typography>
         <ul>
            <li>Te pliki cookie są wykorzystywane na podstawie Twojej uprzedniej zgody.</li>
         </ul>
         <Typography fontWeight="bold">- Cookies mediów społecznościowych</Typography>
         <Typography>
            Euromaster Polska sp. z o.o. stosuje tak zwane wtyczki społecznościowe (dalej: przyciski) odnoszące się do
            sieci społecznościowych takich jak Facebook, Linkedin lub YouTube.
         </Typography>
         <Typography>
            Gdy odwiedzasz naszą stronę internetową, przyciski te są domyślnie wyłączone, co oznacza, że nie wysyłają
            żadnych informacji do danych sieci społecznościowych bez działania z Twojej strony. Przed użyciem tych
            przycisków musisz kliknąć, aby je włączyć. Przyciski pozostają włączone do momentu ich ponownego wyłączenia
            lub usunięcia plików cookie. Po ich włączeniu system łączy się bezpośrednio z serwerem wybranej sieci
            społecznościowej. Zawartość przycisku jest następnie przenoszona bezpośrednio z sieci społecznościowych do
            przeglądarki internetowej, która włącza je do odwiedzanej witryny.
         </Typography>
         <Typography>
            Zaraz po włączeniu przycisku dana sieć społecznościowa może gromadzić dane, niezależnie od tego, czy używasz
            przycisku, czy nie. Jeśli jesteś zalogowany w sieci społecznościowej, może połączyć wizytę na tej stronie z
            Twoim kontem użytkownika. Odwiedziny na innych stronach Euromaster Polska sp. z o.o. zostaną połączone,
            tylko jeśli włączysz odpowiedni przycisk na tych stronach.
         </Typography>
         <Typography>
            Jeśli jesteś członkiem sieci społecznościowej i nie chcesz, aby łączyła ona dane zebrane podczas Twojej
            wizyty na naszej stronie internetowej z informacjami podanymi podczas dołączania do sieci, musisz wylogować
            się z danej sieci społecznościowej przed włączeniem przycisków .
         </Typography>
         <Typography>
            Pamiętaj, że nie mamy wpływu na zakres danych gromadzonych przez sieci społecznościowe za pośrednictwem
            twoich przycisków. Więcej informacji na temat zakresu i celu gromadzenia danych oraz sposobu przetwarzania i
            wykorzystywania takich danych, a także praw i opcji ustawień w celu ochrony prywatności można znaleźć w
            polityce ochronie danych opublikowanym przez dane sieci społecznościowe.
         </Typography>
         <ul>
            <li>Te pliki cookie są wykorzystywane na podstawie Twojej uprzedniej zgody.</li>
         </ul>
      </Box>
   )
}
